module.exports = __webpack_public_path__ + "static/img/quesheng.044a9eb6.png";